import type {
  IOnboardingInitiateSSOClaimProfileBody,
  IOnboardingInitiateSSOClaimProfileRequest,
  IOnboardingInitiateSSOClaimProfileResponse,
} from '@/app-package';

import axios from 'axios';

const initiateSSOClaimProfile = async (
  body: IOnboardingInitiateSSOClaimProfileBody,
) => {
  const url = '/onboarding/claim_sso';

  const config: IOnboardingInitiateSSOClaimProfileRequest = {
    url,
    method: 'post',
    data: body,
  };

  const { data } =
    await axios.request<IOnboardingInitiateSSOClaimProfileResponse>(config);

  return data;
};

export default initiateSSOClaimProfile;
